"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _use_effect = _interopRequireDefault(require("./use_effect"));
var _is_element_overflowing = _interopRequireDefault(require("./is_element_overflowing"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Checks if an element's content has overflow.
 *
 * Element to be checked.
 * @param ref
 *
 * Callback which fires after the overflow has been checked.
 * @param callback
 *
 * Defines if will check horizontal or vertical overflow.
 * @param isVertical
 */
var useIsOverflow = function useIsOverflow(_ref) {
  var ref = _ref.ref,
    callback = _ref.callback,
    isVertical = _ref.isVertical,
    checkResize = _ref.checkResize,
    dependencies = _ref.dependencies;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOverflow = _React$useState2[0],
    setIsOverflow = _React$useState2[1];
  (0, _use_effect.default)(function () {
    var current = ref.current;
    if (!current) return;
    var trigger = function trigger() {
      var hasOverflow = (0, _is_element_overflowing.default)(current, isVertical);
      setIsOverflow(hasOverflow);
      if (callback) callback(hasOverflow);
    };
    if (checkResize) {
      var handleResize = function handleResize() {
        trigger();
      };
      window.addEventListener('resize', handleResize);

      // Initial check
      trigger();
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    } else {
      // Initial check without resize listener
      trigger();
    }
  }, [callback, isVertical, ref, checkResize, dependencies]);
  return isOverflow;
};
var _default = exports.default = useIsOverflow;